import React, { createRef, RefObject, useContext, useRef } from 'react';
import { MediaItem } from '../../services/external-data/types';
import { SearchList } from '../../view/search-list';
import { fetchNewsTabs, fetchNewsList, fetchNewsSearch } from '../../view/search-list/queries';
import { AvailableLanguages } from './available-languages';
import { RocheUITeaser, RocheUITeaserLayout } from '@repo/roche-ui';
import { handleRocheTeaserClick } from '../../helpers/roche-teaser-tracking';
import { RocheXXTranslationContext } from '../../contexts/translation';
import { DateFormattingService } from '../../services/date-time-formatter';

export const RocheMediaReleases = ({ slot }: any): JSX.Element => {
  const teaserRefs = useRef<RefObject<HTMLDivElement>[]>([]);
  const translations = useContext(RocheXXTranslationContext);
  return (
    <SearchList
      slot={slot}
      tabName='year'
      pageName='page'
      queryName='query'
      fetchTabs={fetchNewsTabs}
      fetchList={fetchNewsList}
      fetchSearch={fetchNewsSearch}
    >
      {({ items }) => (
        <>
          {items &&
            items.map((item: MediaItem, index) => {
              const availableLanguages = Object.keys(item.Title || {});
              teaserRefs.current = items.map((_, i) => teaserRefs.current[i] ?? createRef());

              return (
                <RocheUITeaser
                  ref={teaserRefs.current[index]}
                  key={`${item.link}-${index}`}
                  layout={RocheUITeaserLayout.VARIANT_C_WITHOUT_IMAGE}
                  teaserTitle={item.localisedTitle}
                  teaserOverline={DateFormattingService.formatMediaItem(item, translations)}
                  teaserUrl={item.link}
                  teaserOverlineElement={
                    <AvailableLanguages languages={availableLanguages} slug={`media/releases/${item.Slug}`} />
                  }
                  onTeaserClick={(e) =>
                    handleRocheTeaserClick(e, item.localisedTitle, item.link, teaserRefs.current[index])
                  }
                />
              );
            })}
        </>
      )}
    </SearchList>
  );
};
